import React from 'react';
import {ISearchCriteria, SearchMethod} from 'components/forms/SearchSchema';
import api from 'api';
import {IDiplomatObject} from 'types/DiplomatObject';
import {useDispatch} from 'react-redux';
import {useGetApi} from 'common/hooks/useGetApi';
import {usePostApi} from 'common/hooks/usePostApi';
import {layoutActions} from 'features/layout/redux';
import {DialogTypes} from 'common/names';

export enum SearchObjectType {
   PGP,
   SSH,
   SSL,
   Partner,
}

const searchRoutes: Record<SearchObjectType, string> = {
   [SearchObjectType.PGP]: api.searchPgpKeys,
   [SearchObjectType.SSH]: api.searchSshKeys,
   [SearchObjectType.SSL]: api.searchSslKeys,
   [SearchObjectType.Partner]: api.searchPartners,
};

const unusedRoutes: Record<SearchObjectType, string> = {
   [SearchObjectType.PGP]: api.unusedPgpKeys,
   [SearchObjectType.SSH]: api.unusedSshKeys,
   [SearchObjectType.SSL]: api.unusedSslKeys,
   [SearchObjectType.Partner]: api.unusedPartners,
};

const exportRoutes: Record<SearchObjectType, string> = {
   [SearchObjectType.PGP]: api.exportPgpKeys,
   [SearchObjectType.SSH]: api.exportSshKeys,
   [SearchObjectType.SSL]: api.exportSslKeys,
   [SearchObjectType.Partner]: api.exportPartners,
};

export const useSearchApi = (
   type: SearchObjectType,
   exportDialogHeader: string,
   exportDialogContent: string
) => {
   const dispatch = useDispatch();
   const [results, setResults] = React.useState<IDiplomatObject[]>();
   const {request: searchUnused} = useGetApi(unusedRoutes[type], {onSuccess: setResults});
   const {request: searchByField} = useGetApi(searchRoutes[type], {onSuccess: setResults});
   const {request: exportObjects} = usePostApi(exportRoutes[type], {
      onSuccess: () => {
         dispatch(
            layoutActions.openSubDialog({
               id: DialogTypes.AlertDialog.id,
               title: exportDialogHeader,
               content: exportDialogContent,
            })
         );
      },
   });
   return React.useMemo(() => {
      return {
         results,
         search: (values: ISearchCriteria) => {
            if (values.method === SearchMethod.unused) {
               searchUnused();
               return;
            }
            const params = `?${new URLSearchParams({
               searchType: values.searchField,
               searchText: values.containingText,
            })}`;
            searchByField(params);
         },
         exportResults: (path: string) => {
            exportObjects(JSON.stringify({csvFile: path, keys: results}));
         },
      };
   }, [exportObjects, results, searchByField, searchUnused]);
};
